import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Chat } from "../types";
import { ChatService } from "../chat.service";
import { TitleService } from "../title.service";
import { environment } from "@environments/environment";

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.css"],
})
export class SideMenuComponent implements OnInit {
  environment = environment;
  @Input() subscription_id: string = "";
  @Input() response;
  @Output() showResponse = new EventEmitter<any>();
  @Output() clearRes = new EventEmitter<any>();

  constructor(
    private chatService: ChatService,
    private titleService: TitleService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // this.route.queryParams.subscribe((params) => {
    //   this.conversation_id = params["conversation_id"] || "";
    //   if (
    //     this.chats.length === 0 ||
    //     (this.conversation_id &&
    //       !this.chats
    //         .map((c) => c.conversation_id)
    //         .includes(this.conversation_id))
    //   ) {
    //     this.chatService
    //       .getChats(this.subscription_id)
    //       .subscribe((chats: Chat[]) => {
    //         this.chats = chats.sort(
    //           (chat1, chat2) =>
    //             Date.parse(chat2.last_updated) - Date.parse(chat1.last_updated)
    //         );
    //         for (const chat of this.chats) {
    //           if (!chat.title) {
    //             this.titleService
    //               .addTitle(this.subscription_id, chat.conversation_id)
    //               .subscribe((titleResponse) => {
    //                 chat.title = titleResponse.title;
    //               });
    //           }
    //         }
    //       });
    //   } else {
    //     if (this.conversation_id) {
    //       this.newTitle =
    //         this.chats.filter(
    //           (chat) => chat.conversation_id === this.conversation_id
    //         )[0].title || "Untitled chat";
    //     }
    //   }
    // });
  }

  conversation_id: string = "";
  chats: Chat[] = [];
  editMode: boolean = false;
  newTitle: string = "";

  createNewChat(): void {
    this.router.navigate(["/"], {
      queryParams: {
        conversation_id: null,
      },
      queryParamsHandling: "merge",
    });
    this.conversation_id = "";
  }

  handleChatDeletion(conversation_id: string): void {
    this.chatService
      .deleteChat(this.subscription_id, conversation_id)
      .subscribe(() => {
        this.createNewChat();
      });
    this.chats = this.chats.filter(
      (chat) => chat.conversation_id !== this.conversation_id
    );
  }

  displayResponse(response: any): void {
    this.showResponse.emit(response);
  }

  clearResponse(response: any): void {
    this.clearRes.emit("");
  }
}
